export default "<i class=\"material-icons icon\" matTooltip=\"Tiene alguna dependencia\">\n  attach_file\n</i>\n"